const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const getToken = () => {
    // Check for OAuth token first, then fall back to regular JWT
    return localStorage.getItem('oauth_token') || localStorage.getItem('jwt');
};

const getAuthHeader = (token) => {
    if (!token) return {};

    // If token is a JWT (our internal format), use Bearer prefix
    // OAuth tokens are already prefixed with Bearer
    if (localStorage.getItem('jwt') === token) {
        return { 'Authorization': `Bearer ${token}` };
    } else {
        return { 'Authorization': `Bearer ${token}` };
    }
};

const buildUrl = (url) => {
    // If URL is already absolute, return as-is
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }
    // Otherwise, prepend API base URL
    return `${API_BASE_URL}${url}`;
};

export const request = async (url, options = {}) => {
    let token = getToken();
    if (options.token) {
        token = options.token;
    }
    // Default headers
    const headers = {
        ...getAuthHeader(token)
    };

    if (options.json) {
        headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(options.json);
        delete options.json;
    }

    const response = await fetch(buildUrl(url), {
        ...options,
        headers,
        credentials: 'include',
    });

    if (!response.ok) {
        const data = await response.json();
        return Promise.reject({...data, status: response.status});
    }

    // 204 has no body, and response.json() rejects on an empty one. The share
    // revoke endpoint is the first 204 this app calls; every other DELETE here
    // returns a JSON body.
    if (response.status === 204) return null;

    return response.json();
};